const PLATFORMS = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};

const DEVICES = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  PHONE: 'phone',
};

const MOBILE_DEVICE_SCREEN_SIZE = {
  [DEVICES.DESKTOP]: 1200,
  [DEVICES.TABLET]: 991,
  [DEVICES.PHONE]: 768,
};

export {
  PLATFORMS,
  DEVICES,
  MOBILE_DEVICE_SCREEN_SIZE,
}



// WEBPACK FOOTER //
// ./src/common/constants/constants.js